
  import { defineComponent } from "vue";
  import BookHeader from "@/components/book-header.vue";

  export default defineComponent({
    name: "Home",
    components: { BookHeader },
  });
